import { render, staticRenderFns } from "./GroupBubbleRow.vue?vue&type=template&id=6b4c6f1d&scoped=true&"
import script from "./GroupBubbleRow.vue?vue&type=script&lang=js&"
export * from "./GroupBubbleRow.vue?vue&type=script&lang=js&"
import style0 from "./GroupBubbleRow.vue?vue&type=style&index=0&id=6b4c6f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c6f1d",
  null
  
)

export default component.exports